SharedMdl.directive('swiper',[ '$timeout', function( $timeout ) {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			$timeout(function () {

			if ( scope.$last === true || scope.mobile ) {

				var id = element.closest('.filter-strip').attr('id');


				var swiper = new Swiper( '#' + id + ' .swiper-container', {
					paginationClickable: true,
					slidesPerView: 'auto',
					nextButton: '#' + id + ' .swiper-button-next',
					prevButton: '#' + id + ' .swiper-button-prev',
					direction: 'horizontal',
					onInit: function ( swiper ) {
						if( swiper.virtualSize > swiper.width )
							swiper.wrapper.css('justify-content', 'flex-start');
						else
							swiper.wrapper.css('justify-content', 'center');
					},
					initialSlide: ( function(){

						/**
						 * Due to scope issues..
						 * If the current class is on the last element, it can't be detected through a selector.
						 * The good news is that if we didn't find any current class in other elements it must be on the last one.
						 * @type {*|jQuery}
						 */
						var index = $('#' + id + ' .swiper-slide.current').index();

						return index !== -1 ? index : element.index();

					})()
				});


			}
			});
		}
	}
}]);